module.exports = __webpack_public_path__ + "static/media/btn_alien.8a80622f.png";